import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SEO } from 'components';
import { enableAnimations, getCloudinaryUrl } from 'config/helpers';
import { JobOfferContent } from './subcomponents';
import './JobOffer.scss';

export class JobOfferTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: '',
    };
  }

  componentDidMount() {
    enableAnimations();
    this.setState({ location: window.location.href });
  }

  render() {
    const { location } = this.state;
    const { offer } = this.props;
    const { title, settings } = offer.frontmatter;
    const slug = settings.slug || offer.fields.slug;

    return (
      <div className={'single-job-offer'}>
        <SEO
          title={settings.metaTitle || title}
          description={settings.metaDescription}
          cover={getCloudinaryUrl(settings.cover, 'f_auto,q_auto,w_400')}
          slug={slug}
          section="career"
          canonical={settings.canonical}
          cloudinary
        />
        <JobOfferContent windowLocation={location} data={offer.frontmatter} />
      </div>
    );
  }
}

JobOfferTemplate.propTypes = {
  offer: PropTypes.shape().isRequired,
};

export default JobOfferTemplate;
